import React, {Fragment, useState} from 'react';
import { NavLink } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import DefaultLogo from '../../../../assets/img/next/logo.svg';
import CityDropdown from './cityDropdown';
import { updateCity, updateRegion } from '../../../../actions';

import { isMobile } from '../../../../utils/mobile';

const HeaderLogo = ({ city, updateCity, updateRegion, history, user }) => {
  const imageSrc = city?.settings?.web_logo ?? user.region?.web_logo ?? DefaultLogo;
  const [showEnvDropdown, setShowEnvDropdown] = useState(false);
  const [showCityDropdown, setShowCityDropdown] = useState(false);

  const onCityChange = (city) => {
    updateCity(city);
    setShowCityDropdown(false);
    history.push('/');
  };

  const onRegionChange = (region) => {
    updateRegion(region);
    setShowCityDropdown(false);
    history.push('/');
  };

  const handleEnvClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowEnvDropdown(!showEnvDropdown);
  };

  const handleLogoClick = (e) => {
    if (isMobile()) {
      e.preventDefault();
      setShowCityDropdown(!showCityDropdown);
    } else {
      history.push('/');
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div className="logotype" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
        <img alt="" src={imageSrc} height={isMobile() ? "35px" : "55px"} />
        {process.env.REACT_APP_ENV.toLowerCase() !== 'production' && (
          <div className="demo-mode" onClick={handleEnvClick} style={{ cursor: 'pointer' }}>
            {localStorage.getItem('apiEnv') === 'prod' ? ('PROD!') : ('Demo')}
            {showEnvDropdown && (
              <div 
                style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  background: 'white',
                  boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                  zIndex: 1000,
                  borderRadius: '4px',
                  minWidth: '100px'
                }}
              >
                <div 
                  style={{
                    padding: '8px 12px',
                    cursor: 'pointer',
                    backgroundColor: localStorage.getItem('apiEnv') !== 'prod' ? '#f0f0f0' : 'transparent'
                  }}
                  onClick={() => {localStorage.removeItem('apiEnv'); setShowEnvDropdown(false);window.location.reload();}}
                >
                  Demo DB
                </div>
                <div 
                  style={{
                    padding: '8px 12px',
                    cursor: 'pointer',
                    backgroundColor: localStorage.getItem('apiEnv') === 'prod' ? '#f0f0f0' : 'transparent'
                  }}
                  onClick={() => {localStorage.setItem('apiEnv', 'prod'); setShowEnvDropdown(false); window.location.reload();}}
                >
                  Prod DB
                </div>
              </div>
            )}
          </div>
        )}
      </div>
      <CityDropdown 
        cities={user.cities} 
        regions={user.regions}
        onChange={onCityChange}
        onRegionChange={onRegionChange}
        currentCity={user.city}
        currentRegion={user.region}
        isOpen={showCityDropdown}
        onToggle={setShowCityDropdown}
      />
    </div>
  );
};

const mapStateToProps = ({ user }) => ({ user });

const mapDispatchToProps = { updateCity, updateRegion };

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), withRouter);

export default enhance(HeaderLogo);